import { atom } from 'recoil';

export const resumeData = atom({
  key: 'resumeData',
  default: {},
});

export const fileData = atom({
  key: 'fileData',
  default: {},
});

export const getAuth = atom({
  key: 'getAuth',
  default: sessionStorage.getItem('access_token'),
});
